import { WeighingTypeEnum } from "../../domain/model/model-enums";
import { Uuid } from "../../domain/model/uuid/uuid.type";

export class SectionOverviewTrialPhasesViewModel {
  constructor(
    readonly id: Uuid,
    readonly trialId: Uuid,
    readonly number: number,
    readonly type: WeighingTypeEnum,
    readonly expectedStartDate: Date | null,
    readonly expectedEndDate: Date | null,
    readonly expectedStartWeightKg: number | null,
    readonly expectedEndWeightKg: number | null
  ) {

  }
}
